interface DividerProps {
  className?: string;
}

export default function Divider({ className = "" }: DividerProps) {
  return (
    <div className={`flex items-center justify-center py-6 lg:py-12 ${className}`}>
      <span className="h-px w-20 bg-warm-stone/30" />
      <span className="mx-4 text-warm-stone/25">&#9830;&#xFE0E;</span>
      <span className="h-px w-20 bg-warm-stone/30" />
    </div>
  );
}
